<template>
    <span>
          <v-btn icon class="mx-0" @click="deleteTicket()">
                      <v-icon color="pink">delete</v-icon>
          </v-btn>  
        </span>
</template>

<script>
import {deleteModule} from '@/model';

export default {
    name: 'DeleteTicket',
    props:{
        name :{
            required:true
        }
    },
    data() {
        return {
           
         
        };
    },
    methods: {
        deleteTicket() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will delete this ticket, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            
            deleteModule('ticket',this.name,function(response){
              if(response){
                   console.log("This is response: ",response);
                     alert('Ticket has been successfully deleted');
                    self.$store.dispatch('updateTickets'); 
                  }else{
                      console.log(null);
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>